<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Login | STAFF SYNC</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Keep your finances and membership up to date" name="description" />
      <meta content="" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">

      <!-- owl.carousel css -->
      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body class="auth-body-bg">
    <div>
      <div class="container-fluid p-0">
        <div class="row g-0">
          <div class="col-xl-8 col-lg-8">
            <div class="pt-lg-5 p-4 bg-overlay" :style="backgroundStyle">
              <div class="w-100">
                <div class="bg-overlay"></div>
                <div class="d-flex h-100 flex-column">
                  <div class="p-4 mt-auto">
                    <div class="row justify-content-center">
                      <div class="col-lg-7">
                        <div class="text-center">
                          <img :src="county_logo()" alt="Logo" class="img mb-3" style="width: 170px;">
                          <h4 class="mb-0 text-white">
                            <i class="bx bxs-quote-alt-left text-success h1 align-middle me-3"></i>
                            <span>Right there for you</span>
                          </h4>
                          <p class="font-size-16 text-white mb-0">STAFF SYNC</p>
                          <strong>-</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->

          <div class="col-xl-4 col-md-4">
            <div class="auth-full-page-content p-md-5 p-4">
              <div class="w-100">
                <div class="d-flex flex-column h-100">
                  <div class="mb-4 mb-md-5">
                    <a href="index.html" class="d-block auth-logo">
                      <img :src="county_logo()" alt="" height="18" class="auth-logo-dark">
                      <img :src="county_logo()" alt="" height="18" class="auth-logo-light">
                    </a>
                  </div>

                  <div class="my-auto">
                    <div>
                      <h5 class="text-success">Welcome Back!</h5>
                      <p class="text-muted">Sign in to continue Using the <strong>STAFF SYNC</strong></p>
                    </div>

                    <div class="mt-4">
                      <div class="mb-3">
                        <label for="username" class="form-label">Username/Id Number</label>
                        <input
                            v-model="username"
                            type="text"
                            class="form-control"
                            id="username"
                            placeholder="Enter your username"
                            @keyup.enter="login"
                            autocomplete="username"
                        >
                      </div>

                      <div class="mb-3">
                        <div class="float-end">
                          <a href="javascript:void(0);" @click="goToForgotPassword" class="text-muted">
                            <small>Forgot password?</small>
                          </a>
                        </div>
                        <label class="form-label">Password</label>
                        <div class="input-group auth-pass-inputgroup">
                          <input
                              v-model="password"
                              :type="showPassword ? 'text' : 'password'"
                              class="form-control"
                              placeholder="Enter password"
                              aria-label="Password"
                              aria-describedby="password-addon"
                              @keyup.enter="login"
                              autocomplete="current-password"
                          >
                          <button
                              class="btn btn-light"
                              type="button"
                              id="password-addon"
                              @click="showPassword = !showPassword"
                          >
                            <i :class="showPassword ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline'"></i>
                          </button>
                        </div>
                      </div>

                      <div class="form-check">
                        <input
                            v-model="rememberMe"
                            class="form-check-input"
                            type="checkbox"
                            id="remember-check"
                        >
                        <label class="form-check-label" for="remember-check">
                          Remember me
                        </label>
                      </div>

                      <!-- Alert Messages -->
                      <div v-if="alert.success" class="alert alert-success mt-3" role="alert">
                        <i class="mdi mdi-check-circle me-2"></i>{{ message }}
                      </div>

                      <div v-if="alert.info" class="alert alert-primary mt-3" role="alert">
                        <i class="mdi mdi-information me-2"></i>{{ message }}
                      </div>

                      <div v-if="alert.failed" class="alert alert-danger mt-3" role="alert">
                        <i class="mdi mdi-alert-circle me-2"></i>{{ message }}
                      </div>

                      <div class="mt-3 d-grid">
                        <button
                            @click="login"
                            class="btn btn-primary waves-effect waves-light"
                            type="submit"
                            :disabled="isLoading"
                        >
                          <span v-if="!isLoading">Log In</span>
                          <span v-else>
                              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                              Logging in...
                            </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 mt-md-5 text-center">
                    <p class="mb-0">© {{ currentYear }}  <strong>STAFF SYNC</strong></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>
    </body>
  </div>
</template>

<script>
import { authUrl, county_logo, login_bg, execute } from "@/api";
import router from "@/router";

export default {
  name: "LoginPage",
  data() {
    return {
      backgroundUrl: login_bg,
      username: '',
      password: '',
      rememberMe: false,
      showPassword: false,
      isLoading: false,
      message: '',
      alert: {
        success: false,
        info: false,
        failed: false
      },
      deviceDetails: '',
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.backgroundUrl})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      };
    },
  },
  mounted() {
    this.getDeviceDetails();
    // Check if user credentials are remembered
    this.loadRememberedCredentials();
  },
  methods: {
    county_logo() {
      return county_logo;
    },

    goToForgotPassword() {

      this.$router.push('/forgot-password');
    },

    getDeviceDetails() {
      // Operating System
      let os = 'Unknown';
      if (navigator.userAgent.indexOf('Win') !== -1) os = 'Windows';
      else if (navigator.userAgent.indexOf('Mac') !== -1) os = 'MacOS';
      else if (navigator.userAgent.indexOf('Linux') !== -1) os = 'Linux';
      else if (navigator.userAgent.indexOf('Android') !== -1) os = 'Android';
      else if (navigator.userAgent.indexOf('iOS') !== -1) os = 'iOS';

      // Browser
      let browser = 'Unknown';
      if (navigator.userAgent.indexOf('Chrome') !== -1) browser = 'Chrome';
      else if (navigator.userAgent.indexOf('Firefox') !== -1) browser = 'Firefox';
      else if (navigator.userAgent.indexOf('Safari') !== -1) browser = 'Safari';
      else if (navigator.userAgent.indexOf('Edge') !== -1) browser = 'Edge';
      else if (navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode) browser = 'Internet Explorer';

      // Screen Resolution
      const screenResolution = `${window.screen.width} x ${window.screen.height}`;

      // CPU Cores
      const cpuCores = navigator.hardwareConcurrency || 'Unknown';

      // Memory
      const memory = navigator.deviceMemory || 'Unknown';

      this.deviceDetails = `os: ${os} | browser: ${browser} | screenResolution: ${screenResolution} | cpuCores: ${cpuCores} | memory: ${memory}`;
    },

    loadRememberedCredentials() {
      try {
        const rememberedUsername = localStorage.getItem('rememberedUsername');
        const rememberedPassword = localStorage.getItem('rememberedPassword');

        if (rememberedUsername) {
          this.username = rememberedUsername;
          this.rememberMe = true;

          // Load password if it exists (it's base64 encoded for basic obfuscation)
          if (rememberedPassword) {
            try {
              this.password = atob(rememberedPassword);
            } catch (e) {
              console.error('Error decoding saved password');
              localStorage.removeItem('rememberedPassword');
            }
          }
        }
      } catch (error) {
        console.error('Error loading remembered credentials:', error);
      }
    },

    saveRememberedCredentials() {
      try {
        if (this.rememberMe) {
          // Save username and password (password is base64 encoded for basic obfuscation)
          localStorage.setItem('rememberedUsername', this.username);
          localStorage.setItem('rememberedPassword', btoa(this.password));
        } else {
          // Clear remembered credentials
          localStorage.removeItem('rememberedUsername');
          localStorage.removeItem('rememberedPassword');
        }
      } catch (error) {
        console.error('Error saving remembered credentials:', error);
      }
    },

    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    async login() {
      // Validate inputs
      if (!this.username || !this.password) {
        this.clearAlerts();
        this.message = "Please enter both username and password";
        this.alert.failed = true;
        return;
      }

      this.clearAlerts();
      this.message = "Authorizing...";
      this.alert.info = true;
      this.isLoading = true;

      const data = new FormData();
      data.append("function", "loginPortal");
      data.append("email", this.username);
      data.append("password", btoa(this.password));
      data.append("version", "1");
      data.append("deviceDetails", this.deviceDetails);

      try {
        const res = await execute(data, authUrl);

        this.clearAlerts();
        this.isLoading = false;

        if (res.data.success) {
          // Save remember me preference ONLY on successful login
          this.saveRememberedCredentials();

          // Store only the token
          const token = res.data.data.tokenSession.token;
          sessionStorage.setItem("tokenSession", token);

          // Store roles as JSON string
          const roles = res.data.data.roles;
          sessionStorage.setItem("selectedRoles", JSON.stringify(roles));

          // Check if user exists in response
          if (!res.data?.data?.user) {
            // User needs OTP verification
            if (res.data.data.otpLength) {
              sessionStorage.setItem("otpLength", res.data.data.otpLength);
            }
            router.push('otp-verification');
          } else {
            // User data exists
            const userData = res.data.data.user;

            // Store essential user data for session use
            sessionStorage.setItem("isLoggedIn", "true");
            sessionStorage.setItem("userInfo", JSON.stringify({
              names: userData.names,
              idNo: userData.idNo,
              phoneNumber: userData.phoneNumber,
              category: userData.category,
              requireOTP: userData.requireOTP,
              passwordChanged: userData.passwordChanged,
              passwordExpiry: userData.passwordExpiry
            }));

            this.message = res.data.message || "Login successful!";
            this.alert.success = true;

            // Check if password needs to be changed
            if (userData.passwordChanged === 'false' || userData.passwordChanged === false || userData.passwordChanged === '0') {
              // Force password change
              setTimeout(() => {
                router.push('change-password');
              }, 500);
              return;
            }

            // Check if OTP is required
            if (userData.requireOTP === 'true') {
              if (res.data.data.otpLength) {
                sessionStorage.setItem("otpLength", res.data.data.otpLength);
              }
              router.push('otp');
            } else {
              // Redirect based on user category
              setTimeout(() => {
                if (userData.category === 'EMPLOYEE') {
                  router.push('employee-dashboard');
                } else {
                  router.push('dashboard');
                }
              }, 500);
            }
          }
        } else {
          // Login failed - don't save credentials
          sessionStorage.setItem("isLoggedIn", "false");
          this.alert.failed = true;
          this.message = res.data.message || "Login failed. Please check your credentials.";
        }
      } catch (error) {
        this.clearAlerts();
        this.isLoading = false;
        this.alert.failed = true;
        this.message = error.message || "An error occurred during login. Please try again.";
        console.error("Login error:", error);
      }
    }
  }
}
</script>

<style scoped>
.auth-full-bg {
  background-color: rgba(85, 110, 230, 0.25);
  display: flex;
  height: 100vh;
}

.auth-full-bg::before {
  content: "";
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
}

.bg-overlay {
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
}

.auth-full-page-content {
  min-height: 100vh;
  display: flex;
  align-items: center;
}

/* Loading spinner animation */
.bx-spin {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.form-check-input {
  cursor: pointer;
}

.form-check-label {
  cursor: pointer;
}
</style>